export enum UserKindTypes {
  User = 1,
  Client = 2,
}

export const getUserKindName = (userKindId: UserKindTypes): string => {
  if (userKindId === UserKindTypes.User) {
    return 'User'
  }

  if (userKindId === UserKindTypes.Client) {
    return 'Client'
  }

  return '-'
}

export enum UserKindFilterKey {
  userKindId = 'UserKindId',
}
